import { render, staticRenderFns } from "./HandIns.vue?vue&type=template&id=2cb8e561&"
import script from "./HandIns.vue?vue&type=script&lang=js&"
export * from "./HandIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports